export var SignInActionData;
(function (SignInActionData) {
    SignInActionData["NEXT"] = "next";
    SignInActionData["SIGN_IN"] = "signIn";
})(SignInActionData || (SignInActionData = {}));
//# sourceMappingURL=sign-in-action-data.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-dto/sign/sign-in-action-data.js
// module id = 982
// module chunks = 14